/* eslint-disable */
import React, { useMemo, useRef, useState } from "react";
import { Box } from "@mui/material";
import { TargetStepProps } from "../../target-configurator.types";
import SidebarStepFooter from "src/modules/striim-ai-sidebar/tools/tql-tools/source-configurator/sidebar-step-footer";
import ValidationList, {
    ValidationListStatus,
    SetAPIStatusProperty
} from "src/modules/wizards/common/validation-list/validation-list";
import { checkTargetPrivileges, validateConnection } from "src/modules/wizards/services";
import { ValidationListRef } from "src/modules/flow-designer/vts/select-tables-modal/components/validation-list/validation-list";

const VALIDATION_TIMEOUT = 2_000;

const ValidateTargetStep = ({ state, onNext, onBack, onCancel }: TargetStepProps) => {
    const [apiStatus, setAPIStatus] = useState<SetAPIStatusProperty>({});
    const validationRef = useRef<ValidationListRef>(null);

    const targetInfo = useMemo(() => ({ defaultProperties: {}, targetFormValues: state.formValues }), [
        state.formValues
    ]);

    const validationItems = useMemo(
        () => [
            {
                status: ValidationListStatus.Todo,
                text: "Trying to reach your target",
                method: () => validateConnection(state.targetType, targetInfo)
            },
            {
                status: ValidationListStatus.Todo,
                text: "Validating Permissions",
                method: () => checkTargetPrivileges(state.targetType, targetInfo)
            }
        ],
        []
    );

    const handleRetry = () => {
        if (apiStatus.canRetry) {
            setAPIStatus({});
            validationRef.current?.retryAPI();
        } else {
            setTimeout(onNext, VALIDATION_TIMEOUT);
        }
        setAPIStatus(prev => ({ ...prev, isAPISuccessful: false, isAPICompleted: false }));
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ mb: 2 }}>
                <ValidationList
                    ref={validationRef}
                    validationList={validationItems}
                    async={true}
                    onSuccess={onNext}
                    setAPIStatus={setAPIStatus}
                    controlAppWizardFooter={false}
                />
            </Box>
            <SidebarStepFooter
                onCancel={onCancel}
                onBack={onBack}
                onNext={handleRetry}
                showNext={!!apiStatus.canRetry}
                nextDisabled={!apiStatus.isAPICompleted}
                backDisabled={!apiStatus.isAPICompleted}
                nextLabel={apiStatus.canRetry ? "Retry" : "Next"}
            />
        </Box>
    );
};

export default ValidateTargetStep;
